import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SexyModule} from '@qid/sexy';

@Component({
  selector: 'super-step-item',
  templateUrl: './super-step-item.component.html',
  styleUrls: ['./super-step-item.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
  ],
})
export class SuperStepItemComponent implements OnInit {
  @Input() count: any;
  @Input() isTopLine: boolean = true;
  @Input() isBottomLine: boolean = true;
  @Input() success: boolean = false;
  constructor() {}

  ngOnInit() {}
}
